import { useRef, useState } from 'react';
import type { AreaDto, TaskListDto } from '@werft/contracts';
import { t } from '../../i18n/index.js';
import { newUuid } from '../../platform/api.js';
import { createList, listName } from './structureActions.js';
import { AddTaskInput } from './TaskList.js';

/**
 * Leerer Bereich ohne Liste (Audit F04): In jeder Aufgabenansicht gibt es einen direkten nächsten Schritt. Die erste
 * Aufgabe legt im Hintergrund eine Liste im gewählten Bereich an (Name = Bereich) – niemand muss das Datenmodell
 * erraten. Eine Liste mit eigenem Namen bleibt über „Liste hinzufügen“ möglich.
 */
export function FirstTask(props: { projectId: string; areaId: string | null; areas: AreaDto[]; allLists: TaskListDto[]; canCreate: boolean }) {
  // Eine feste ID je Anzeige: Liste und Aufgaben landen zusammen, auch wenn mehrere Zeilen eingefügt werden
  const [listId] = useState(newUuid);
  const created = useRef(false);
  const area = props.areas.find((a) => a.id === props.areaId);
  const name = area?.name ?? listName({ name: null });
  return (
    <div className="space-y-2 rounded-xl border border-dashed border-zinc-300 p-4 dark:border-zinc-700">
      <p className="text-sm text-zinc-600 dark:text-zinc-300">{props.canCreate ? t('areas.firstTask') : t('areas.noLists')}</p>
      {props.canCreate && (
        <AddTaskInput
          projectId={props.projectId}
          listId={listId}
          autoFocus
          placeholder={t('areas.firstTaskPlaceholder')}
          draftKey={`first.${props.projectId}.${props.areaId ?? 'allgemein'}`}
          ensureList={() => {
            if (created.current) return;
            created.current = true;
            void createList(props.projectId, name, props.allLists, props.areaId, listId);
          }}
        />
      )}
    </div>
  );
}
